import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Helmet } from 'react-helmet';

import Layout from 'components/common/Layout';
import Progress from 'components/common/Progress';
import SystemSettingsEditForm from 'components/settings/SystemSettingsEditForm';

import { fetchSystemSettings } from 'redux/modules/systemSettings';

import { appTitle, titleSeparator } from 'config/helmetSettings';

class System extends Component {
  componentDidMount() {
    const { actions } = this.props;
    actions.fetchSystemSettings({
      triggerLoading: true,
    });
  }

  render() {
    const { systemSettings, loading } = this.props;

    return (
      <Layout variant="settings">
        <Helmet>
          <title>
            {appTitle} {titleSeparator} System Settings
          </title>
        </Helmet>
        {loading > 0 ? (
          <Progress />
        ) : (
          <SystemSettingsEditForm
            form="systemSettingsEditForm"
            initialValues={systemSettings}
          />
        )}
      </Layout>
    );
  }
}

System.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  systemSettings: PropTypes.object.isRequired,
  loading: PropTypes.number.isRequired,
  actions: PropTypes.shape({
    fetchSystemSettings: PropTypes.func.isRequired,
  }).isRequired,
};

const mapStateToProps = store => ({
  systemSettings: store.systemSettings.data,
  loading: store.systemSettings.loading,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ fetchSystemSettings }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(System);



// WEBPACK FOOTER //
// ./src/pages/settings/System.js